import React, {useEffect, useState} from 'react';
import './App.css';
import {useAuthState} from "react-firebase-hooks/auth";
import _ from "lodash";
import {appConfig, auth, logout} from "./modules/firebase/client-app";
import Layout from "./modules/layout/layout";
import AppContext from './modules/common/context/app-context';
import {getSingleUser} from "./modules/security/services/user-data-service";
import LoginDetail from "./modules/security/components/login-detail";
import ShowNoAccessMessage from "./modules/security/components/show-no-access-message";
import GoogleWebFontLoader from "./modules/common/fonts/google-web-font-loader";

const DEFAULT_SHOPIFY_DETAIL = {
    products: [],
    productIds: [],
    total: 0,
};

const SHOPIFY_LOCAL_STORAGE_KEY = appConfig.appKey + ".shopify";

const App = () => {
    const [profile, setProfile] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, loading, error] = useAuthState(auth);
    const [shopifyDetail, setShopifyDetail] = useState(DEFAULT_SHOPIFY_DETAIL);

    useEffect(() => {
        if (!loading && user) {
            processLoggedInUser();
            /*if (user) {
                setIsAuthenticated(true);
                setProfile(user);
                loadShopifyDetail();
            } else {
                setIsAuthenticated(false);
            }*/
        }
    }, [loading, user]);

    const processLoggedInUser = async () => {
        if (user) {
            setIsAuthenticated(true);
            const userInfo = await getSingleUser(user?.uid);
            const userDetail = userInfo?.data();
            const currentUser = _.cloneDeep(user);
            currentUser['isEnabled'] = userDetail?.isEnabled || false;

            setProfile(currentUser);
            loadShopifyDetail();
        } else {
            setIsAuthenticated(false);
        }
    }

    const addShopifyProduct = (product) => {
        const existingShopifyDetail = {...shopifyDetail} || DEFAULT_SHOPIFY_DETAIL;

        if (existingShopifyDetail.productIds.indexOf(product.id) === -1) {
            existingShopifyDetail.products.push(product);
            setProductsInShopify(existingShopifyDetail.products);
        }
    };

    const addAllShopifyProducts = (productsList) => {
        const existingShopifyDetail = {...shopifyDetail} || DEFAULT_SHOPIFY_DETAIL;

        _.forEach(productsList, (product) => {
            if (existingShopifyDetail.productIds.indexOf(product.id) === -1) {
                existingShopifyDetail.products.push(product);
            }
        });

        setProductsInShopify(existingShopifyDetail.products);
    };

    const removeShopifyProduct = (product) => {
        const existingShopifyDetail = {...shopifyDetail} || DEFAULT_SHOPIFY_DETAIL;

        if (existingShopifyDetail.productIds.indexOf(product.id) !== -1) {
            existingShopifyDetail.products = _.filter(existingShopifyDetail.products, (existingProduct) => {
                return existingProduct.id !== product.id;
            });

            setProductsInShopify(existingShopifyDetail.products);
        }
    }

    const clearSelectedShopifyProducts = () => {
        setProductsInShopify([]);
    }

    const setProductsInShopify = (updatedProducts) => {
        const existingShopifyDetail = {...shopifyDetail};
        existingShopifyDetail.products = updatedProducts;
        existingShopifyDetail.productIds = _.map(existingShopifyDetail.products, 'id');
        existingShopifyDetail.total = existingShopifyDetail.products.length;

        setShopifyDetail(existingShopifyDetail);
        localStorage.setItem(SHOPIFY_LOCAL_STORAGE_KEY, JSON.stringify(existingShopifyDetail));
    };

    const clearCart = () => {
        setShopifyDetail(DEFAULT_SHOPIFY_DETAIL);
        localStorage.setItem(SHOPIFY_LOCAL_STORAGE_KEY, JSON.stringify(DEFAULT_SHOPIFY_DETAIL));
    }

    const loadShopifyDetail = () => {
        const currentShopifyDetailText = localStorage.getItem(appConfig.appKey + ".shopify");

        if (!_.isEmpty(currentShopifyDetailText) && currentShopifyDetailText !== 'undefined') {
            const currentShopifyDetail = JSON.parse(currentShopifyDetailText);
            setShopifyDetail(currentShopifyDetail);
            localStorage.setItem(SHOPIFY_LOCAL_STORAGE_KEY, JSON.stringify(currentShopifyDetail));
        }
    }

    const initiateLogout = () => {
        logout();
        setProfile(null);
        setIsAuthenticated(false);
    }

    return (

        <AppContext.Provider
            value={{
                user: {user},
                profile: {profile},
                isAuthenticated: !_.isEmpty(user),
                isEnabled: profile?.isEnabled,
                initiateLogout: initiateLogout,
                shopifyDetail: shopifyDetail,
                addShopifyProduct: addShopifyProduct,
                removeShopifyProduct: removeShopifyProduct,
                clearSelectedShopifyProducts: clearSelectedShopifyProducts,
                addAllShopifyProducts: addAllShopifyProducts,
            }}>

            {!loading &&
                <>
                    {isAuthenticated && profile?.isEnabled &&
                        <Layout></Layout>
                    }

                    {_.isEmpty(user) && !isAuthenticated &&
                        <LoginDetail/>
                    }

                    {isAuthenticated && profile && !profile?.isEnabled &&
                        <ShowNoAccessMessage/>
                    }
                </>
            }


            {/*{!loading && isAuthenticated &&
                <Layout></Layout>
            }

            {!loading && _.isEmpty(user) && !isAuthenticated &&
                <LoginDetail/>
            }

            {isAuthenticated && profile && !profile?.isEnabled &&
                <ShowNoAccessMessage/>
            }*/}

        </AppContext.Provider>
    );
}

export default App;
